import utils from '../../api/utils'
import server from '../../api/server'

const state = {
}

// getters
const getters = {
  getEmailHeaderReport: state => {
    return (company) => {
      const getHeadName = (head) => {
        return (head ? head.firstName + ' ' + head.middleName : '').toUpperCase()
      }
      var head = company.heads && company.heads.length > 0 ? company.heads[0] : null
      return `${company.name.value}\nОГРН ${company.ogrn}, ИНН ${company.inn}\n\n${head ? head.nameShort : ''}\n${company.address && company.address.value ? company.address.value : ''}\n\nИсх. № _____ от "__" _____________ 20__ г.\nНа вн. № _____ от "__" _____________ 20__ г.\n\nУВАЖАЕМЫЙ(АЯ) ${getHeadName(head)}! `
    }
  },
  getAgreementHeader1Report: state => {
    return (company, clientCompany) => {
      const footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля Стороны-2 будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.'
      var cstr1 = company ? `${company.name.value} (${company.nameShort})` : `________________ ________________`
      var hstr1 = company && company.heads && company.heads.length > 0 ? `${company.heads[0].position} ${company.heads[0].nameShort}` : `________________ ________________`
      var cstr2 = clientCompany ? `${clientCompany.name.value} (${clientCompany.nameShort})` : `________________ ________________`
      var hstr2 = clientCompany && clientCompany.heads && clientCompany.heads.length > 0 ? `${clientCompany.heads[0].position} ${clientCompany.heads[0].nameShort}` : `________________ ________________`
      return `${cstr1}, именуемое в дальнейшем "Сторона-1", в лице ${hstr1}, действующего на основании Устава, с одной стороны, и ${cstr2}, именуемое в дальнейшем "Сторона-2", в лице ${hstr2}, действующего на основании Устава, с другой стороны, заключили настоящий договор о нижеследующем. ${clientCompany ? '' : '\n\n' + footer}`
    }
  },
  getAgreementHeader2Report: state => {
    return (company, clientCompany) => {
      const footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля Стороны-2 будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.'
      var cstr1 = company ? `${company.nameShort}` : `________________`
      var hstr1 = company && company.heads && company.heads.length > 0 ? `${company.heads[0].position} ${company.heads[0].nameShort}` : `________________ ________________`
      var cstr2 = clientCompany ? `${clientCompany.nameShort}` : `________________`
      var hstr2 = clientCompany && clientCompany.heads && clientCompany.heads.length > 0 ? `${clientCompany.heads[0].position} ${clientCompany.heads[0].nameShort}` : `________________ ________________`
      return `${hstr1}, действующий на основании Устава и от имени ${cstr1}, именуемое в дальнейшем "Сторона-1", с одной стороны, и ${hstr2}, действующий на основании Устава и от имени ${cstr2}, именуемое в дальнейшем "Сторона-2", с другой стороны, заключили настоящий договор о нижеследующем. ${clientCompany ? '' : '\n\n' + footer}`
    }
  },
  getAgreementFooterReport: state => {
    return (company, clientCompany, companyInfo, clientInfo) => {
      const footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля Стороны-2 будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.'
      const _f = (value, emptySize) => {
        return value !== null ? value : '_'.repeat(emptySize)
      }

      const createModel = () => {
        return {
          company: {
            head: {
              position: null,
              nameShort: null
            },
            nameShort: null,
            ogrn: null,
            inn: null,
            kpp: null,
            address: {
              value: null
            }
          },
          info: {
            phone: null,
            email: null,
            bankDetails: {
              account: null,
              bankName: null,
              corrAccount: null,
              bankBic: null
            }
          }
        }
      }
      const getModel = (company, info) => {
        var model = createModel()
        if (company) {
          if (company.heads && company.heads.length > 0) {
            model.company.head.position = company.heads[0].position
            model.company.head.nameShort = company.heads[0].nameShort
          }
          model.company.nameShort = company.nameShort
          model.company.ogrn = company.ogrn
          model.company.inn = company.inn
          model.company.kpp = company.kpp
          model.company.address.value = company.address.value
        }
        if (info) {
          model.info.phone = info.phone
          model.info.email = info.email
          model.info.bankDetails.account = info.bankDetails.account
          model.info.bankDetails.bankName = info.bankDetails.bankName
          model.info.bankDetails.corrAccount = info.bankDetails.corrAccount
          model.info.bankDetails.bankBic = info.bankDetails.bankBic
        }
        return model
      }
      var model1 = getModel(company, companyInfo && companyInfo.isRefreshed ? companyInfo : null)
      var model2 = getModel(clientCompany, clientInfo && clientInfo.isRefreshed ? clientInfo : null)

      const side = (model) => `${_f(model.company.nameShort, 20)}\nОГРН ${_f(model.company.ogrn, 16)}, ИНН ${_f(model.company.inn, 10)}, КПП ${_f(model.company.kpp, 10)}\nАдрес: ${_f(model.company.address.value, 40)}\n\nБанковские реквизиты:\nр/с ${_f(model.info.bankDetails.account, 20)}\nв ${_f(model.info.bankDetails.bankName, 22)}\nк/с ${_f(model.info.bankDetails.corrAccount, 20)}\nБИК ${_f(model.info.bankDetails.bankBic, 9)}\n\nТел.: ${model.info.phone ? model.info.phone : '+7 (___) ____-___-___'}\nЭл.почта: ${model.info.email ? model.info.email : '________@___________.__'}`

      var sign = (model) => `${_f(model.company.nameShort, 20)}\n${_f(model.company.head.position, 20)}\n\n${_f(null, 20)} /${_f(model.company.head.nameShort, 20)}`
      return `РЕКВИЗИТЫ СТОРОН\n\nСторона-1:\n${side(model1)}\n\nСторона-2:\n${side(model2)}\n\n\nПОДПИСИ СТОРОН\n\nСторона-1:\n${sign(model1)}\n\nСторона-2:\n${sign(model2)}${clientInfo && clientInfo.isRefreshed ? '' : '\n\n' + footer}`
    }
  },
  getClientEnvelopeReport: state => {
    return (company, clientCompany) => {
      const footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля отправителя письма (от кого, откуда) будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.'
      const _f = (value, emptySize) => {
        return value !== null ? value : '_'.repeat(emptySize)
      }
      const splitAddress = (address) => {
        if (!address || !address.value) {
          return null
        }
        var alist = address.value.split(',')
        if (alist.length <= 1) {
          return null
        }
        var index = alist[1].trim()
        alist.splice(1, 1)
        return {index: index, address: alist.join(',')}
      }
      const createModel = () => {
        return {
          company: {
            head: {
              position: null,
              nameShort: null
            },
            nameShort: null,
            address: {
              value: null,
              index: null
            }
          }
        }
      }
      const getModel = (company) => {
        var model = createModel()
        if (company) {
          if (company.heads && company.heads.length > 0) {
            model.company.head.position = company.heads[0].position
            model.company.head.nameShort = company.heads[0].nameShort
          }
          model.company.nameShort = company.nameShort
          var a = splitAddress(company.address)
          model.company.address.value = a.address
          model.company.address.index = a.index
        }
        return model
      }

      const side1 = (m) => `От кого: ${_f(m.company.nameShort, 21)}\n${_f(m.company.head.position, 15)} ${_f(m.company.head.nameShort, 15)}\n\nОткуда: ${_f(m.company.address.value, 21)}\n${_f(m.company.address.index, 6)}`
      const side2 = (m) => `Кому: ${_f(m.company.nameShort, 21)}\n${_f(m.company.head.position, 15)} ${_f(m.company.head.nameShort, 15)}\n\nКуда: ${_f(m.company.address.value, 21)}\n${_f(m.company.address.index, 6)}`
      return `${side1(getModel(clientCompany))}\n\n${side2(getModel(company))}${clientCompany ? '' : '\n\n' + footer}`
    }
  }
}

// actions
const actions = {
  copyToClipboard ({commit, state}, request) {
    var res = false
    if (!request) {
      return
    }
    // res = utils.copyTextToClipboard(text)
    if (request.text && !request.html) {
      res = utils.copyTextToClipboard(request.text)
    } else {
      res = utils.copyContentToClipboard(request.html, request.text)
    }
    if (res) {
      commit('setStatus', {show: true, type: 'success', message: 'Данные скопированы в буфер обмена.'})
    } else {
      commit('setStatus', {show: true, type: 'info', message: 'К сожалению, Ваш браузер не позволяет автоматически копировать текст. Данные подготовлены, нажмите "Ctrl-C"'})
    }
  },
  mailTo ({commit, state}, {email, subject, emailBody}) {
    email = encodeURIComponent(email)
    subject = encodeURIComponent(subject)
    var eBody = encodeURIComponent(emailBody)
    var link = 'mailto:' + email + '?subject=' + subject + '&body=' + eBody
    var size = link.length
    if (size < 2048) {
      document.location = link
      return
    }
    var res = utils.copyTextToClipboard(emailBody)
    if (res) {
      eBody = '<ВСТАВЬТЕ ДАННЫЕ ИЗ БУФЕРА ОБМЕНА>'
      eBody = encodeURIComponent(eBody)
      link = 'mailto:' + email + '?subject=' + subject + '&body=' + eBody
      document.location = link
      commit('setStatus', {show: true, type: 'info', message: `К сожалению, Ваш браузер не позволяет автоматически сформировать письмо размером ${size} байт. Вы можете это сделать вручную. Данные скопированы в буфер обмена.`})
    } else {
      commit('setStatus', {show: true, type: 'info', message: 'К сожалению, Ваш браузер не позволяет автоматически сформировать письмо, Вы можете это сделать вручную. Данные подготовлены, нажмите "Ctrl-C" для копирования в буфер обмена'})
    }
  },
  shareTo ({commit, state}, {email, subject, emailBody}) {
    if (!email && (navigator.share !== undefined)) {
      navigator.share({
        title: subject,
        text: emailBody
      })
      .then(() => {})
      .catch((e) => commit('setErrorStatus', {error: e, context: 'Ошибка в функции поделиться браузера '}))
    } else {
      this.dispatch('mailTo', {email: email || '', subject: subject, emailBody: emailBody})
    }
  },
  openLocation ({commit, state}, location) {
    let popUp = window.open(location, '_blank')
    if (!popUp) {
      commit('setStatus', {show: true, type: 'info', message: 'К сожалению, Ваш браузер не позволяет открывать всплывающие окна'})
    }
  },
  sendTo ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var item = Object.assign({}, request)
      server.apiPost(
        '/api/me/companies/command-mail-sends',
        item,
        (data) => {
          commit('setStatus', {show: true, type: 'success', message: 'Письмо подготовлено и поставлено в очередь.'})
          this.dispatch('fetchDashboardCounters')
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при посылке письма'})
          reject(e)
        }
      )
    })
  }
}

// mutations
const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js